module.exports = __webpack_public_path__ + "img/los-cabos-cabo-pulmo.d19af169.jpg";